export default class InvoiceDocumentation {

  id = null;
  documentType = 'INVOICE_TASK';
  name = null;
  fileType = '';
  size = '';
  fileName = '';
  md5 = '';
  startDate = null;
  endDate = null;
  signed = false;
  toBeSigned = false;
  generated = false;
  assignedTo = null;
  customer = null;
  isGlobal = false;
  task = null;
  price = 0.0;
  factuallyCorrect = false;
  technicallyCorrect = false;
  description = '';
  supplier = '';
  supplierId = null;
  invoiceNumber = "";
  constructor() {
  }
}
